import type { DashboardUserProfile } from '@services/firebase'
import type { FlashcardCard } from '@services/firebase/flashcards'
import type { LightboxItem } from '@shared/media/lightbox/lightbox-captions'
import { resolvePreferredAudioSource } from '@shared/media/audio/audio-source'
import { resolveFlashcardTranslation } from './flashcard-language'

export function getSelectedFlashcards({
  cards,
  selectedCardIds,
}: {
  readonly cards: FlashcardCard[]
  readonly selectedCardIds: string[]
}) {
  return cards.filter((card) => selectedCardIds.includes(card.id))
}

export function getPlayableFlashcards(cards: FlashcardCard[]) {
  return cards.filter((card) => card.featuredImage)
}

export function getFlashcardLightboxItems({
  cards,
  locale,
  profile,
}: {
  readonly cards: FlashcardCard[]
  readonly locale: string
  readonly profile: DashboardUserProfile | null
}): LightboxItem[] {
  return cards
    .filter((card) => card.featuredImage)
    .map((card) => ({
      audio: resolvePreferredAudioSource({ card, profile }),
      imageUrl: card.featuredImage as string,
      subtitle: resolveFlashcardTranslation(card, locale),
      title: card.title ?? 'Flashcard',
    }))
}
